/* eslint-disable @typescript-eslint/no-explicit-any */
// Utils
import { mutateFiltersGet, mutatePackSite } from 'utils/packSite'
// App Actions
import { addNotification } from 'context/AppContext/actions';
// Actions
import * as eventActions from 'context/PackSiteContext/actions';
// Flags
import * as eventConstants from 'context/PackSiteContext/statusFlags';
// Services
import { getProdDataData, patchProdDataData, postProdDataData } from 'services/prodDataV1/prodData';
// Types
import { APIResponseProps } from 'types/global';
import * as types from './types';

// @ts-ignore

export async function getProdDataDetails({
  appDispatch,
  packSitesDispatch,
  filters,
  orgRef,
}:types.GetPackSitesProps) {
  packSitesDispatch(eventActions.setPackSiteState(eventConstants.GET_PACK_SITE));
  // const response = dummyFetch();
  // await response.then(val => handleOrganisationSuccess(val, packSitesDispatch));
  const { errorMessage, response }:APIResponseProps = await getProdDataData({
    reqParams: mutateFiltersGet(filters),
  });
  if (response) {
    const { packSites, metadata } = response;
    if (filters.offSet === 0) {
      packSitesDispatch(eventActions.setPackSites(packSites));
    } else {
      packSitesDispatch(eventActions.appendPackSites(packSites));
    }

    // Call next offset if no fildered order found
    if (packSites.length === 0 && metadata.links.next !== null ) {
      packSitesDispatch(eventActions.setPackDetailFilters({ ...filters, offSet : filters.offSet + 100  }));
    }

    // Update no more packsite
    packSitesDispatch(eventActions.setNoMorePackSite(metadata.links.next !== null))
    // await delay(500);
    packSitesDispatch(eventActions.setPackSiteState(eventConstants.GET_PACK_SITE_SUCCESS));
  }
  if (errorMessage) {
    packSitesDispatch(eventActions.setPackSiteState(eventConstants.GET_PACK_SITE_ERROR));
    packSitesDispatch(eventActions.setNoMorePackSite(false));
    if (errorMessage === 'User Details Not Found') {
      packSitesDispatch(eventActions.setPackSites([]));
    }
    if (filters.offSet > 0) {
      appDispatch(addNotification({
        label: 'Some error has occured. Unable to retireve data from system',
        type: 'success',
      }))
    }
  }
}

export async function patchProdDataDetails({
  appDispatch,
  packSitesDispatch,
  packDetailFilters,
  packsite,
}: types.PostPackSitesProps) {
  packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE));
  try {
    const { response, errorMessage }:APIResponseProps = await patchProdDataData({
      data: mutatePackSite(packsite),
      indexId: packsite.indexId,
    });
    if (response) {
      packSitesDispatch(eventActions.setPackSites([]));
      packSitesDispatch(eventActions.setPackDetailFilters({ ...packDetailFilters, offSet : 0 }));
      packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE_SUCCESS));
      appDispatch(addNotification({
        label: 'Pack Site entries have been saved',
        type: 'success',
      }));
    }
    if (errorMessage) {
      packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE_ERROR));
      appDispatch(addNotification({
        label: 'An Error Occurred Submitting Packsites',
        type: 'error',
      }));
    }
    
  } catch (error: any) {
    let errorMessage;
    if (error.errorCode === '409') {
      errorMessage = 'Some Packsites Are No Longer In Fail Status';
    } else if (error.errorCode) {
      errorMessage = 'An Error Occurred Submitting Packsites';
    } else {
      errorMessage = error.message;
    }
    packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE_ERROR));
    appDispatch(addNotification({
      label: errorMessage,
      type: 'error',
    }))
  }
}

export async function postProdDataDetails({
  appDispatch,
  packSitesDispatch,
  packDetailFilters,
  packsite,
}: types.PostPackSitesProps) {
  packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE));
  try {
    const { errorMessage }:APIResponseProps = await postProdDataData({
      data: mutatePackSite(packsite),
    });
    if (errorMessage) {
      let message = '';
      if (errorMessage === 'Error: Request failed with status code 409') {
        message = 'Pack Site Rule Already Exists';
      } else {
        message = 'An Error Occurred Submitting Packsites';
      }
      packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE_ERROR));
      appDispatch(addNotification({
        label: message,
        type: 'error',
      }));
    } else {
      packSitesDispatch(eventActions.setPackSites([]));
      packSitesDispatch(eventActions.setPackDetailFilters({ ...packDetailFilters, offSet : 0 }));
      packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE_SUCCESS));
      appDispatch(addNotification({
        label: 'Packsites successfully submitted',
        type: 'success',
      }))
    }
  } catch (error: any) {
    let errorMessage;
    if (error.errorCode === '409') {
      errorMessage = 'Some Packsites Are No Longer In Fail Status';
    } else if (error.errorCode) {
      errorMessage = 'An Error Occurred Submitting Packsites';
    } else {
      errorMessage = error.message;
    }
    packSitesDispatch(eventActions.setPackSiteState(eventConstants.POST_PACK_SITE_ERROR));
    appDispatch(addNotification({
      label: errorMessage,
      type: 'error',
    }))
  }
}
